export function PrivacyPage() {
  return (
    <div className="max-w-3xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Privacy Policy</h1>

      <div className="prose prose-sm text-gray-700 space-y-4">
        <p className="text-sm text-gray-500">Last updated: May 2026</p>

        <h2 className="text-lg font-semibold mt-6">1. Information We Collect</h2>
        <p>
          We collect information you provide directly to us, such as when you create an account,
          make a request, or contact us for support. This includes your name, email address,
          and any other information you choose to provide.
        </p>

        <h2 className="text-lg font-semibold mt-6">2. How We Use Your Information</h2>
        <p>
          We use the information we collect to provide, maintain, and improve our services,
          communicate with you, and protect the rights, property, and safety of Connectfy,
          our users, and the public.
        </p>

        <h2 className="text-lg font-semibold mt-6">3. Information Sharing</h2>
        <p>
          We do not sell, trade, or otherwise transfer your personal information to third parties
          without your consent, except as described in this policy or as required by law.
        </p>

        <h2 className="text-lg font-semibold mt-6">4. Data Security</h2>
        <p>
          We implement appropriate security measures to protect your personal information against
          unauthorized access, alteration, disclosure, or destruction. However, no method of
          transmission over the Internet is 100% secure.
        </p>

        <h2 className="text-lg font-semibold mt-6">5. Cookies</h2>
        <p>
          We use session cookies to maintain your authenticated session. These cookies are
          essential for the operation of the portal and are not used for tracking purposes
          beyond authentication.
        </p>

        <h2 className="text-lg font-semibold mt-6">6. Contact</h2>
        <p>
          If you have questions about this Privacy Policy, please contact us at
          connectfy@zohomail.com.au.
        </p>
      </div>
    </div>
  );
}